export const PLACEHOLDERS = {
    input: 'Search or create item',
    copy: 'Copy',
    copied: 'Copied',
    paste: 'Paste',
    pasted: 'Pasted',
    clearAll: 'Clear all',
    selected: 'Selected:',
    create: 'Create',
    total: 'Total',
    totalSeparator: 'of',
    sortOrderAsc: 'A-Z',
    sortOrderDesc: 'Z-A',
    errorTitle: 'Error',
    errorAccessDenied: 'Clipboard access denied',
    errorAccessError: 'Clipboard access error',
    errorValueExists: 'Value already exists',
    errorValueEmpty: 'Value cannot be empty',
};
export const LIST_MAX_HEIGHT = 333;
export const ITEM_HEIGHT = 37;
